import React from 'react';
import { createRoot } from 'react-dom/client';
import { Form } from '../../../component/interview/report/Form';
import Client from '../../../model/api/Client';

const element = document.getElementById('interview-report-form');

if (element) {
	const root = createRoot(element);
	const client = new Client();
	root.render(
		<Form
			modal={window.Modal}
			apiClient={client}
			codexUrl={element.dataset.codexUrl}
			termsUrl={element.dataset.termsUrl}
			gdprUrl={element.dataset.gdprUrl}
			defaultEmail={element.dataset.email}
			defaultName={element.dataset.name}
		/>
	);
}
